module.exports = "<ngb-alert *ngIf=\"alert\"\n           [type]=\"alert.type\" (close)=\"closeAlert()\">\n  {{ alert.text | translate | async }}\n</ngb-alert>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Templates/alert.html
// module id = ./src/app/Templates/alert.html
// module chunks = main